<template>
  <div>
    <el-dialog
      title="意向报名"
      v-loading.fullscreen.lock="loading"
      :visible="delistingShow"
      :close-on-click-modal="false"
      width="60%"
      @close="close"
    >
      <div class="dia_wrap">
        <el-form
          class="form"
          ref="formRef"
          :model="formData"
          :rules="rules"
          label-position="left"
          label-width="110px"
          size="mini"
        >
          <div class="h_bg p50" style="margin-top: 0">
            <h3>摘牌人信息</h3>
            <span>带“<span class="redF xing">*</span>”号为必填项</span>
          </div>
          <div class="m50">
            <el-form-item label="申请人身份">
              <el-radio-group
                v-model="formData.userType"
                @change="changeRadio"
                :disabled="Boolean(isPromisePayed)"
              >
                <el-radio label="2">企业</el-radio>
                <el-radio label="3">组织</el-radio>
                <el-radio label="1">个人</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="姓名"
              prop="name"
              v-if="formData.userType == 1"
            >
              <el-input
                class="input_width"
                v-model="formData.name"
                disabled
                placeholder="请输入姓名"
                :maxlength="10"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="身份证号"
              prop="identityCode"
              v-if="formData.userType == 1"
            >
              <el-input
                class="input_width"
                v-model.trim="formData.identityCode"
                disabled
                placeholder="请输入身份证号"
                :maxlength="18"
              ></el-input>
            </el-form-item>
            <el-form-item
                label="法定代表人"
                prop="legalPerson"
                v-if="formData.userType == 2"
            >
              <el-input
                  class="input_width"
                  v-model="formData.legalPerson"
                  :disabled="Boolean(isPromisePayed)"
                  placeholder="请输入法定代表人"
                  :maxlength="10"
              ></el-input>
            </el-form-item>
            <el-form-item
                label="企业名称"
                prop="enterpriseName"
                v-if="formData.userType == 2"
            >
              <el-input
                  class="input_width"
                  v-model="formData.enterpriseName"
                  :disabled="Boolean(isPromisePayed)"
                  placeholder="请输入企业名称"
                  :maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item
                label="统一信用代码"
                prop="creditCode"
                v-if="formData.userType == 2"
            >
              <el-input
                  class="input_width"
                  v-model="formData.creditCode"
                  :disabled="Boolean(isPromisePayed)"
                  placeholder="请输入统一信用代码"
                  :maxlength="50"
                  @change="getAuthInfo"
              ></el-input>
            </el-form-item>
            <el-form-item
                label="注册住址"
                prop="registAddress"
                v-if="formData.userType == 2"
            >
              <el-input
                  class="input_width"
                  v-model="formData.registAddress"
                  :disabled="Boolean(isPromisePayed)"
                  placeholder="请输入注册住址"
                  :maxlength="100"
              ></el-input>
            </el-form-item>
            <el-form-item label="组织名称" prop="name" v-if="formData.userType == 3">
              <el-input
                  class="input_width"
                  v-model.trim="formData.name"
                  :disabled="Boolean(isPromisePayed)"
                  placeholder="请输入组织名称"
                  :maxlength="20"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系人"  v-if="formData.userType == 3" prop="contactPerson">
              <el-input
                  class="input_width"
                  v-model.trim="formData.contactPerson"
                  :disabled="Boolean(isPromisePayed)"
                  placeholder="请输入联系人"
                  :maxlength="20"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input
                class="input_width"
                v-model.trim="formData.contactPhone"
                :disabled="Boolean(isPromisePayed)"
                placeholder="请输入联系电话"
                :maxlength="20"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="联系地址"
              prop="contactAddress"
              v-if="formData.userType == 1||formData.userType == 3"
            >
              <el-input
                class="input_width"
                v-model="formData.contactAddress"
                :disabled="Boolean(isPromisePayed)"
                placeholder="请输入联系地址"
                :maxlength="100"
              ></el-input>
            </el-form-item>
          </div>
          <div>
            <div class="h_bg p50" style="margin-top: 0">
              <h3>上传相关资料</h3>
            </div>
            <div class="tips-box">
              <p>意向受让方需提交以下材料：</p>
              <p>1.<strong>个人：</strong>需提交个人身份证复印件、受让申请书；</p>
              <p>2.<strong>组织和企业：</strong>需提交营业执照复印件/组织机构代码证、经办人身份证复印件、受让申请书。（经办人非单位法定代表人的，还须提供单位法人授权委托书、单位法定代表人身份证复印件。）</p>
              <p>注：复印件均需加盖单位公章。</p>
              <p>下载模板：<a v-if="assignmentList.length>0" :href="assignmentList[0].downloadUrl">{{assignmentList[0].fileName}}</a></p>
            </div>
          </div>
          <div class="m50">
            <el-form-item label="相关资料" prop="needStat">
              <Upload
                  v-model="fileUrlInfo"
                  @fileNameEvt="fileNameEvt"
                  buttonText="上传资料"
                  :size="true"
              ></Upload>
              <div
                  v-for="(item, index) in formData.delistingInfos"
                  :key="index"
              >
                <div class="lookAddr">
                  <span class="name">{{ item.name }}</span>
                  <el-link
                      class="mr20 blueC"
                      :underline="false"
                      v-if="item.url"
                      :href="item.url"
                      target="_blank"
                  >详情</el-link
                  >
                  <i
                      @click.prevent.stop="
                      formData.delistingInfos.splice(index, 1)
                    "
                      class="el-icon-delete"
                  ></i>
                </div>
              </div>
            </el-form-item>
            <el-row class="mt20">
              <el-col v-for="item of fileList" :key="item.fileType">
                <div v-if="item.maxNumber == 1">
                  <el-form-item
                      :label="item.fileName"
                      label-width="330px"
                      style="margin-bottom: 10px"
                      :class="{ actives: item.isRequire }"
                  >
                    <OneUpload :fileFuther="item" />
                  </el-form-item>
                </div>
                <div v-else>
                  <el-form-item
                      :label="`${item.fileName}(可上传多份)`"
                      label-width="330px"
                      style="margin-bottom: 10px"
                      :class="{ actives: item.isRequire }"
                  >
                    <ListUpload :fileFuther="item" />
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="btn">
        <el-button @click="close">取 消</el-button>
        <el-button class="sumbit" @click="newSaveAndSubmitBtn()"
          >确认提交</el-button
        >
      </div>
    </el-dialog>
    <Dialog :show="applayShow" @dialogClose="applayShow=false" :img="'success.png'" :title="'温馨提示'" content="资料已提交<br/>需要等待管理人员进行审核" :btn="'返回'" btn2="查看我的申请" />
  </div>
</template>

<script>
import Upload from "@/components/Upload/UpLoad.vue";
import Dialog from '@/components/Dialog';
import publicFunction from '@/utils/publicFunction'
export default {
  props: {
    delistingShow: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: '',
    },
    businessType: {
      type: String,
      default: '',
    }
  },
  components: {
    Upload,
    Dialog
  },
  data() {
    return {
      assignmentList: [],
      loading: false,
      applayShow: false,
      formData: {
        needStat: 1,
        listingApplyId: "",
        payMethod: "2", // 1 代收代付  2 自行转账
        delistingInfos: [], // 上传的资料
        userType: "1", //  用户类型 1 个人 2 企业
        name: "", // 姓名 （个人必填）
        identityCode: "", // 身份证号 （个人必填）
        contactPhone: "", // 联系电话 （个人必填）
        legalPerson: "", // 法定代表人 （企业必填）
        enterpriseName: "", //企业名称 （企业必填）
        registAddress: "", //注册地址 （企业必填）
        contactAddress: "", //联系地址 （企业必填）
        creditCode: "", //统一代码 （企业必填）
        contactPerson: "" //联系人
      },
      rules: {
        needStat: [{ required: true, message: "请上传文件", trigger: "blur" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        identityCode: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
        contactPhone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
        legalPerson: [
          { required: true, message: "请输入法人姓名", trigger: "blur" },
        ],
        enterpriseName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        registAddress: [
          { required: true, message: "请输入注册住址", trigger: "blur" },
        ],
        contactAddress: [
          { required: true, message: "请输入联系住址", trigger: "blur" },
        ],
        creditCode: [
          { required: true, message: "请输入统一信用代码", trigger: "blur" },
        ],
        contactPerson:  [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ]
      },
      fileUrlInfo: "",
      fileName: "",
      fileList: [],
      isPromisePayed: 0
    };
  },
  mounted() {
    this.formData.name = this.$store.state.userInfo.name;
    this.formData.identityCode = this.$store.state.userInfo.idCard;
  },
  methods: {
    //获取下载模板
    async getProcessFiles() {
      await this.$api.my.getProcessFiles({ generatePosition: 14, role: '6', listingMode: 10}).then((res) => {
        if (res.code === 1000) {
          this.assignmentList = res.data
        }
      }).catch((err) => {});
    },
    newSaveAndSubmitBtn() {
      this.$refs.formRef.validate((v) => {
        if (v) {
          if (
            this.isPromisePayed != 1 &&
            !this.formData.delistingInfos.length
          ) {
            return this.$message.error("请上传相关资料");
          }
          if (this.formData.userType == 1) {
            if (!publicFunction.isIdCard(this.formData.identityCode)) {
              return this.$message.error("身份证填写错误");
            }
            if (
              !publicFunction.isPhone(this.formData.contactPhone) ||
              !publicFunction.isTel(this.formData.contactPhone)
            ) {
              return this.$message.error("联系号码填写错误");
            }
          }
          this.formData = {
            ...this.formData,
            listingApplyId: this.data.id
          }
          this.loading = true
          this.$api.my.delistingMaterial(this.formData).then(res => {
            this.loading = false
            if(res.code == 1000){
              this.applayShow = true
              // this.$message.success("提交申请成功")
              this.close()
            }
          })
        }
      });
    },
    dialogSumbitR(){
      this.$router.push({name: 'myHanger'})
    },
    dialogSumbitL() {
      if(this.applayShow){
        this.applayShow = false
      }
    },
    fileNameEvt(v) {
      this.fileName = v;
    },
    close() {
      this.$emit("dialogCloses", false);
    },
    //查询当前企业是否可用其他方式摘牌
    async getAuthInfo() {
      if (this.formData.creditCode) {
        if (this.data.tranferType == 1) return; ///申请报价return
        this.loading = true;
        await this.$api.apply
          .getAuthInfo({
            areaConfigId: this.data.areaConfigId,
            unifiedCreditCode: this.formData.creditCode,
            type: 0,
          })
          .then((res) => {
            if (res.data.status != null) {
              this.applyStatus = res.data.status * 1;
            } else {
              this.applyStatus = 2;
            }
          })
          .catch((error) => {})
          .finally(() => {
            this.loading = false;
          });
      }
    },
    // 重置信息
    changeRadio() {
      this.$refs.formRef.clearValidate()
      if (this.formData.userType==1){
        this.formData.name = this.$store.state.userInfo.name;
        this.formData.identityCode = this.$store.state.userInfo.idCard;
      }else {
        this.formData.name = "";
        this.formData.identityCode = "";
      }
      this.formData.contactPhone = "";
      this.formData.creditCode = "";
      this.formData.legalPerson = "";
      this.formData.enterpriseName = "";
      this.formData.registAddress = "";
      this.formData.contactPerson = "";
      this.formData.contactAddress = "";
    },
  },
  watch: {
    fileUrlInfo: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData.delistingInfos.push({
            url: newVal,
            name: this.fileName,
          });
          this.fileUrlInfo = "";
          this.fileName = "";
        }
      },
    },
    delistingShow(newVal){
      if(newVal){
        this.getProcessFiles()
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.btn {
  text-align: center;
  margin: auto;
  display: block;
}
</style>
